module.exports = __webpack_public_path__ + "static/media/steps_a.106f81a3.png";